<template>
    <v-container fluid>
        <!-- top row -->
        <v-layout align-center justify-space-around row fill-heignt>
            <loading 
                :active.sync="loadingResults" 
                :can-cancel="false" 
                :is-full-page="false"
                loader="dots"
                color="#4caf50"
                :height="80"
                :width="80"
                :opacity="0.7"
            ></loading>
            <!-- empty flex -->
            <v-flex xs0 md0 lg2></v-flex>
            <!-- timeframe and pickers -->
            <v-flex xs3 sm5 md4 lg3 pr-1>
                <v-layout 
                    column 
                    class="grey lighten-3 rounded-block vld-parent"
                    fill-heignt 
                    >
                    <!-- timeframe -->
                    <v-flex xs10 pb-3 class="text-xs-center" px-3>
                        <v-flex class="subheading" pb-1>Timeframe</v-flex>
                        <v-select
                            :items="timeframes"
                            item-value="value"
                            item-text="title"
                            v-model="selectedTimefame"
                            label="Timeframe"
                            solo
                            height="35"
                        ></v-select>
                    </v-flex>
                    <!-- date pickers -->
                    <v-layout row justify-space-around>
                        <v-flex xs5 pl-2 pb-2>
                            <!-- Date from -->
                            <v-menu
                                v-model="isDatepickerFromVisible"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :disabled="datesSelectable"
                                lazy
                                transition="scale-transition"
                                full-width
                                min-width="290px"
                                offset-y
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="datepickerFrom"
                                        label="Date From"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="datepickerFrom" 
                                    @input="isDatepickerFromVisible = false"
                                    :max="datepickerTo || this.dates.today"
                                    :min="this.dates.minSelectable"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs5 pr-2 pb-1>
                            <!-- Date to -->
                            <v-menu
                                v-model="isDatepickerToVisible"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :disabled="datesSelectable"
                                lazy
                                transition="scale-transition"
                                full-width
                                min-width="290px"
                                offset-y
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="datepickerTo"
                                        label="Date To"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="datepickerTo" 
                                    @input="isDatepickerToVisible = false"
                                    :min="datepickerFrom"
                                    :max="this.dates.today"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex> 
                    </v-layout>
                </v-layout>
            </v-flex>
            <!-- campaign and os -->
            <v-flex xs4 sm4 md4 lg3 px-2>
                <v-layout column class="grey lighten-3 rounded-block vld-parent">
                    <v-flex xs12 class="text-xs-center" px-3>
                        <v-flex class="subheading" pb-1>Campaign</v-flex>
                        <v-select
                            :items="campaignsList"
                            item-value="external_id"
                            item-text="name"
                            v-model="selectedCampaign"
                            label="Campaign"
                            solo
                            height="35"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center" px-3>
                        <v-flex class="subheading" pb-1>OS</v-flex>
                        <v-select
                            :items="os"
                            item-value="value"
                            item-text="title"
                            v-model="selectedOS"
                            :disabled="OSDropdownDisabled"
                            label="OS"
                            solo
                            height="35"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!-- group by elements -->
            <v-flex xs2 sm2 md2 lg2 style="max-width: 240px">
                <v-layout column class="grey lighten-3 rounded-block vld-parent" align-left>
                    <v-flex xs12 class="text-xs-center" px-3>
                        <v-switch v-model="groupByCampaign"
                            :disabled="selectedCampaign !== '0'"
                            color="success"
                            label="Group by campaign"
                            style="max-width: 220px; height: 74px; padding-top:15px;"
                        ></v-switch>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center" px-3>
                        <v-switch v-model="groupByOS"
                            :disabled="OSGroupByDisabled"
                            color="success"
                            label="Group by OS"
                            style="max-width: 220px; height: 74px; padding-top:10px;"
                        ></v-switch>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!-- empty flex -->
            <v-flex xs0 lg2></v-flex>
        </v-layout>
        <!-- row with alerts -->
        <v-layout justify-center align-center>
             <v-flex xs12 sm10 md8 lg4>
                <v-alert
                    :value="customDatesNotSelected"
                    :dismissible="true"
                    type="info"
                >
                    Please select a range of dates to show results
                </v-alert>
                <v-alert
                    :value="testAlerts || !userCampaignsOk"
                    :dismissible="true"
                    v-if="!loadingResults"
                    type="warning"
                >
                    Sorry, there was a problem loading your campaigns
                </v-alert>
                <v-alert
                    :value="testAlerts || noCampaignsAlert"
                    :dismissible="true"
                    v-if="!loadingResults"
                    type="info"
                >
                    No campaigns available
                </v-alert>
                <v-alert
                    :value="testAlerts || userDataError"
                    :dismissible="true"
                    v-if="!loadingResults"
                    type="warning"
                >
                    Sorry, there was a problem loading your data
                </v-alert>
                <v-alert
                    :value="testAlerts || userDataEmpty"
                    :dismissible="true"
                    v-if="!loadingResults"
                    type="info"
                >
                    No data available
                </v-alert>
            </v-flex>
        </v-layout>
        <br>
        <br>
        <!-- data table row -->
        <v-layout align-center justify-space-around row fill-heignt>
            <v-flex xs12 lg8 xl8 v-if="!customDatesNotSelected">
                <AdvertDataTable 
                    :rows="this.data_records"
                    :timeframe="selectedTimefame"
                    :campaign="selectedCampaign"
                    :os="selectedOS"
                    :osOptions="os"
                    :dateFrom="datepickerFrom"
                    :dateTo="datepickerTo"
                    :groupByCampaign="groupByCampaign"
                    :groupByOS="groupByOS"
                    v-if="this.data_records.length"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvertDataTable from './AdvertDataTable'
import { mapGetters } from 'vuex'

const dates = {
    mtdFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
    mtdTo: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
    lastMonthFrom: new Date(new Date().getFullYear(), new Date().getMonth()-1, 2).toISOString().substr(0, 10),
    lastMonthTo: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
    days30from: new Date(new Date().setDate(new Date().getDate()-30)).toISOString().substr(0, 10),
    days30to: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
    days7from: new Date(new Date().setDate(new Date().getDate()-7)).toISOString().substr(0, 10),
    days7to: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
    yesterday: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
    today: new Date().toISOString().substr(0, 10),
    minSelectable: new Date(new Date().getFullYear(), new Date().getMonth()-1, 1).toISOString()
}

export default {
    name: 'AdvertDashboard',
    components: {
        AdvertDataTable,
        Loading
    },
    data() {
        return {
            timeframes: [
                {title:'MTD', value: 'mtd'},
                {title:'Last Month', value:'lastmonth'},
                {title:'30 Days', value:'30days'},
                {title: '7 Days', value: '7days'},
                {title: 'Yesterday', value: 'yesterday'},
                {title: 'Custom range', value:'custom'}
            ],
            selectedTimefame: 'mtd',
            selectedCampaign: '0',
            os: [
                {title:'All', value:'0'},
                {title:'Android', value:'10'},
                {title:'iOS', value:'11'},
                {title:'Other', value:'12'},
            ],
            selectedOS: '0',
            data_records: [],
            loadingResults: false,
            userDataEmpty: false,
            userDataError: false,
            testAlerts: false,

            groupByCampaign: false,
            groupByOS: false,

            dates: dates,
            datepickerFrom: null,
            datepickerTo: null,

            isDatepickerFromVisible: false,
            isDatepickerToVisible: false,
        }
    },
    methods: {
        loadUserData() {
            this.loadingResults = true
            this.userDataEmpty = false
            this.userDataError = false
            axios.get('summary/')
            .then(resp =>{
                this.data_records = resp.data
                // API may return [{}] in some cases
                if (!resp.data.length || (resp.data.length === 1 && Object.keys(resp.data[0]).length === 0)) {
                    this.userDataEmpty = true
                }
            })
            .catch(err =>{
                console.log(err)
                this.userDataError = true
            })
            .then(() => {
                this.loadingResults = false})
        },
    },
    computed: {
        ...mapGetters([
            'getUserCampaigns',
            'userCampaignsOk',
        ]),
        allCampaignsSelected() {
            // return this.selectedCampaign === '0' ? true : false
            if (this.selectedCampaign === '0') {
                // also set OS to 'All'
                // eslint-disable-next-line
                this.selectedOS = '0'
                return true
            } else {
                return false
            }
        },
        campaignsList() {
            let campaigns = JSON.parse(JSON.stringify(this.getUserCampaigns))
            campaigns.unshift({
                name:'All',
                external_id:'0'
            })

            return campaigns
        },
        noCampaignsAlert() {
            return !this.getUserCampaigns.length && this.userCampaignsOk
        },
        datesSelectable() {
            if (this.selectedTimefame === 'mtd') {
                this.datepickerFrom = dates.mtdFrom
                this.datepickerTo = dates.mtdTo
            } else if (this.selectedTimefame === 'lastmonth') {
                this.datepickerFrom = dates.lastMonthFrom
                this.datepickerTo = dates.lastMonthTo
            } else if (this.selectedTimefame === '30days') {
                this.datepickerFrom = dates.days30from
                this.datepickerTo = dates.days30to
            } else if (this.selectedTimefame === '7days') {
                this.datepickerFrom = dates.days7from
                this.datepickerTo = dates.days7to
            } else if (this.selectedTimefame === 'yesterday') {
                this.datepickerFrom = dates.yesterday
                this.datepickerTo = dates.yesterday
            } else if (this.selectedTimefame === 'custom') {
                this.datepickerFrom = null
                this.datepickerTo = null         
            }

            if (this.selectedTimefame === 'custom') {
                return false
            } else {
                return true
            }
        },
        customDatesNotSelected() {
        if (this.selectedTimefame === 'custom' && (this.datepickerFrom === null || this.datepickerTo === null)) {
            return true
        }
        return false
        },
        OSDropdownDisabled() {
            return this.selectedCampaign === '0' && !this.groupByCampaign
        },
        OSGroupByDisabled() {
            if (this.selectedCampaign === '0' && !this.groupByCampaign) {
                return true
            } else if (this.selectedCampaign !== '0' && this.selectedOS !== '0') {
                return true
            } else if (this.selectedCampaign === '0' && this.groupByCampaign && this.selectedOS !== '0') {
                return true
            } else {
                return false
            }
        }
    },
    created() {
        if (!this.data_records.length){
            this.loadUserData()
        }        

        if (!this.$store.state.campaigns) {
            this.$store.dispatch('fetchUserCampaigns')
        }
    },
    beforeUpdate() {
        if (this.selectedCampaign !== '0' && this.groupByCampaign) {
            this.groupByCampaign = false
        } 

        if (this.selectedOS !== '0') {
            this.groupByOS = false
        }

        if (this.selectedCampaign === '0' && !this.groupByCampaign) {
            this.groupByOS = false
            this.selectedOS = '0'
        }
    }
}
</script>

<style>
.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot{
    min-height: auto!important;
    display: flex!important;
    align-items: center!important;
  }
.v-alert {
    height: 40px;
    border-radius: 10px;
    font-size: 1.2em;
}
.v-alert__dismissible .v-icon {
    align-self: baseline;
    vertical-align: text-top;
    height: 0px;
    /* vertical-align: middle; */
    /* margin-top: -25px; */
}
</style>
